import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TwcModule } from '@topcon/twc-angular';

import { FullScreenLoaderComponent } from './full-screen-loader.component';

@NgModule({
    imports: [TwcModule, CommonModule],
    declarations: [FullScreenLoaderComponent],
    exports: [FullScreenLoaderComponent],
})
export class FullScreenLoaderModule {}
